import React from 'react';
import { Container } from 'reactstrap';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import PropTypes from 'prop-types';
import HeaderContainerTemplate from '../containers/templates/HeaderContainerTemplate';
import DeucePremiumComponent from '../components/DeucePremiumComponent';
import routeConstants from '../utils/routeConstants';
import './styles/DeucePremiumScreen.scss';

const DeucePremium = ({ dispatch }) => (
  <HeaderContainerTemplate>
    <Container>
      <div className="deuce-premium-scene">
        <DeucePremiumComponent
          routeToSubscription={ () =>
            dispatch(push(routeConstants.SUBSCRIPTION_PAGE))
          }
        />
      </div>
    </Container>
  </HeaderContainerTemplate>
);

DeucePremium.propTypes = {
  dispatch: PropTypes.func.isRequired
};

export default connect()(DeucePremium);



// WEBPACK FOOTER //
// ./src/scenes/DeucePremium.js